import React from "react";
import { HorizontalNavBar } from "components/HorizontalNavBar/HorizontalNavBar";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
// import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { Routes } from "constants/routes";

export const NavigationTabs = () => {
  return (
    <HorizontalNavBar
      tabs={[
        {
          value: "users",
          label: "Users",
          icon: <PermIdentityOutlinedIcon />,
          to: Routes.users,
          matchRouts: [Routes.users]
        }
        // {
        //   value: "teams",
        //   label: "Teams",
        //   icon: <PeopleAltOutlinedIcon />,
        //   to: Routes.teams,
        //   matchRouts: [Routes.teams]
        // },
        // {
        //   value: "investmentEntities",
        //   label: "Investment entities",
        //   to: Routes.investmentEntities,
        //   matchRouts: [Routes.investmentEntities]
        // }
      ]}
    />
  );
};
